import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=235ec7d1&scoped=true"
import script from "./doc.vue?vue&type=script&lang=js"
export * from "./doc.vue?vue&type=script&lang=js"
import style0 from "./doc.vue?vue&type=style&index=0&id=235ec7d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ec7d1",
  null
  
)

export default component.exports